import React from 'react';
import { useSpotlightsQuery } from '../../api/spotlights';
import { LoadingState } from '../common/LoadingState';
import { ErrorMessage } from '../common/ErrorMessage';
import { EmptyState } from '../common/EmptyState';
import { SpotlightDetails } from './SpotlightDetails';

import { useTranslation } from 'react-i18next';

export const SpotlightsDashboard: React.FC = () => {
  const { t } = useTranslation('pleri/pages');
  const { data, isLoading, error } = useSpotlightsQuery();

  const allSpotlights = data?.data?.spotlights || [];

  // Filter out spotlights that don't have affected assets
  // Extract assetIds from spotlightResources array
  const spotlights = allSpotlights.filter((spotlight) => {
    const assetIds = spotlight.spotlightResources?.map((r) => r.assetId) || [];
    return assetIds.length > 0;
  });

  if (isLoading) {
    return (
      <div className="flex-1 p-6">
        <LoadingState text={t('loadingSpotlights')} />
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex-1 p-6">
        <ErrorMessage
          message={(error as Error)?.message || t('failedToLoadSpotlights')}
          onDismiss={() => {}}
        />
      </div>
    );
  }

  if (spotlights.length === 0) {
    return (
      <div className="flex-1 p-6">
        <EmptyState
          title={t('noSpotlightsFound')}
          description={t('thereAreCurrentlyNoSpotlightsToDisplay')}
        />
      </div>
    );
  }

  const totalSpotlights = data?.meta?.total || 0;

  return (
    <div className="flex-1 px-32">
      <div className="pt-6 pb-6">
        <h2 className="text-2xl leading-tight font-semibold text-gray-900 dark:text-gray-100">
          {t('spotlights', { totalSpotlights })}
        </h2>
      </div>
      <div className="space-y-6 pb-10">
        {spotlights.map((spotlight) => (
          <SpotlightDetails key={spotlight.id} spotlight={spotlight} />
        ))}
      </div>
    </div>
  );
};
